import { formHeaders } from "@";
import axios from "axios";


export const uploadZipFileToDigitalOcean = async (
  uploadUrl: string,
  zipFileContent: File,
): Promise<any> => {

  try {
    return await axios.put(uploadUrl, zipFileContent, {
      onUploadProgress: formHeaders.onUploadProgress,
      headers: {
        "Content-Type": "application/zip",
        "x-amz-acl": "public-read",
      },
    });
  } catch (error) {
    throw error;
  }
};
